import L from 'leaflet';
import { config } from '../config/environment';

if (!window.L) window.L = L;
require('leaflet.gridlayer.googlemutant/dist/Leaflet.GoogleMutant.js');

/**
 * Harita altlığı: Google Haritalar — Partner Web ile aynı harita, aynı anahtar.
 *
 * Eskiden Carto altlığı kullanılıyordu; Carto anahtarsız erişimi kapatınca haritaların
 * yerinde "API KEY REQUIRED" yazısı çıktı. Katmanlar (ısı haritası, kurye işaretçileri,
 * bölge sınırları) Leaflet'te kalır; yalnız alttaki harita Google'dan gelir.
 */

const SCRIPT_ID = 'hizliyo-google-maps';

/** Partner Web'deki koyu harita stiliyle aynı (bkz. partner: components/map/mapStyles.ts). */
export const DARK_MAP_STYLE = [
    { elementType: 'geometry', stylers: [{ color: '#1d2530' }] },
    { elementType: 'labels.text.stroke', stylers: [{ color: '#1d2530' }] },
    { elementType: 'labels.text.fill', stylers: [{ color: '#8ea0b5' }] },
    { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#2a3542' }] },
    { featureType: 'road', elementType: 'labels.text.fill', stylers: [{ color: '#9fb0c3' }] },
    { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#16202b' }] },
    { featureType: 'poi', stylers: [{ visibility: 'off' }] },
    { featureType: 'transit', stylers: [{ visibility: 'off' }] },
];

/** Açık haritada da işletme ve durak simgeleri gizlenir: önemli olan bizim katmanlarımız. */
const LIGHT_MAP_STYLE = [
    { featureType: 'poi', stylers: [{ visibility: 'off' }] },
    { featureType: 'transit', stylers: [{ visibility: 'off' }] },
];

let bootstrap = null;

/** Google Haritalar betiğini sayfaya BİR KEZ ekler; bütün haritalar aynı yüklemeyi paylaşır. */
function loadGoogleMaps() {
    if (window.google?.maps?.Map) return Promise.resolve();
    if (bootstrap) return bootstrap;

    bootstrap = new Promise((resolve, reject) => {
        const waitUntilReady = (tries = 0) => {
            if (window.google?.maps?.Map) { resolve(); return; }
            if (tries > 100) { reject(new Error('gmaps-timeout')); return; }
            setTimeout(() => waitUntilReady(tries + 1), 100);
        };

        const script = document.createElement('script');
        script.id = SCRIPT_ID;
        script.src = `https://maps.googleapis.com/maps/api/js?key=${config.GOOGLE_MAPS_API_KEY}`;
        script.async = true;
        script.onload = () => waitUntilReady();
        script.onerror = () => reject(new Error('gmaps-load-error'));
        document.head.appendChild(script);
    });

    // Tek bir ağ hatası sekme ömrü boyunca haritayı öldürmesin: sonraki harita yeniden dener.
    bootstrap.catch(() => {
        bootstrap = null;
        document.getElementById(SCRIPT_ID)?.remove();
    });

    return bootstrap;
}

/**
 * Leaflet haritasına Google altlığını ekler. Betik yüklenene kadar harita boş durur;
 * bu sırada harita kaldırılırsa (sayfadan çıkıldı) hiçbir şey eklenmez.
 */
export function addGoogleBaseLayer(map, { dark = false } = {}) {
    let removed = false;
    map.once('unload', () => { removed = true; });

    loadGoogleMaps()
        .then(() => {
            if (removed) return;
            L.gridLayer.googleMutant({
                type: 'roadmap',
                maxZoom: 21,
                styles: dark ? DARK_MAP_STYLE : LIGHT_MAP_STYLE,
            }).addTo(map);
        })
        .catch(() => { /* altlık gelmezse katmanlar yine çizilir */ });
}
